import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { SplitService } from './split.service';

@Directive({ selector: '[patientUiSplitOn]' })
export class SplitOnDirective implements OnInit, OnDestroy {
  @Input('patientUiSplitOn') flagName!: string;
  @Input() patientUiSplitOnDefault = true;

  private sub?: Subscription;
  private hasView = false;

  constructor(
    private readonly tpl: TemplateRef<unknown>,
    private readonly vcr: ViewContainerRef,
    private readonly split: SplitService
  ) {}

  ngOnInit(): void {
    this.sub = this.split
      .isOn$(this.flagName, this.patientUiSplitOnDefault)
      .subscribe((on) => {
        if (on && !this.hasView) {
          this.vcr.createEmbeddedView(this.tpl);
          this.hasView = true;
        } else if (!on && this.hasView) {
          this.vcr.clear();
          this.hasView = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
